import { render } from "./QuestionChoiceScene.vue?vue&type=template&id=c98915f0&scoped=true"
import script from "./QuestionChoiceScene.vue?vue&type=script&lang=js"
export * from "./QuestionChoiceScene.vue?vue&type=script&lang=js"

import "./QuestionChoiceScene.vue?vue&type=style&index=0&id=c98915f0&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c98915f0"]])

export default __exports__